export default theme => ({
  blockContainer: {
    position: 'relative',
    height: '100%',
    width: '100vw',
    minWidth: 1400,
    backgroundColor: theme.palette.blue.light,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      height: 'initial',
      // minHeight: '100%',
      width: '100%',
      minWidth: 'initial',
      padding: 0,
      backgroundColor: theme.palette.blue.main,
      paddingTop: theme.spacing(2),
    },
  },
  background: {
    position: 'absolute',
    zIndex: 1,
    height: '100%',
    width: '100vw',
    minWidth: 1400,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  blueCircle: {
    position: 'absolute',
    height: '90%',
    width: '50%',
    top: 0,
    right: 0,
    background: `no-repeat url(${theme.url('/blocks/b7-blue-circle.svg')})`,
    backgroundSize: 'contain',
    backgroundPosition: 'right top',
  },
  content: {
    zIndex: 5,
    margin: theme.spacing(12),
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(24),
      margin: 0,
      [theme.breakpoints.down('xs')]: {
        paddingTop: theme.spacing(12),
      },
    },
  },
});
